module.exports = __webpack_public_path__ + "static/img/prod_pic09.5550bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic09.jpg
// module id = e26C
// module chunks = 5